import React, { useState, useEffect, useRef, useCallback } from 'react';
import './PhotographerPortfolio.css';
import logo from './assets/logo.png'; // Adjust path as needed
import Modal from './modal';
import { useNavigate, useParams } from 'react-router-dom';
import { 
    doc, 
    getDoc, 
    setDoc,
    deleteDoc,
    collection, 
    query, 
    where, 
    getDocs, 
    limit, 
    addDoc, 
    serverTimestamp,
    orderBy,
    updateDoc,
    increment,
    Timestamp
} from 'firebase/firestore';
import { ref, listAll, getDownloadURL } from 'firebase/storage';
import { db, storage, auth } from '../firebase';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { toast } from 'react-toastify';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

// Local Storage Helper
const LocalStorageHelper = {
    saveLoginData: (userId, email, name, userType = 'user') => {
        localStorage.setItem('isLoggedIn', 'true');
        localStorage.setItem('userId', userId);
        localStorage.setItem('userEmail', email);
        localStorage.setItem('userName', name);
        localStorage.setItem('userType', userType);
    },

    isLoggedIn: () => {
        return localStorage.getItem('isLoggedIn') === 'true';
    },

    getLoginData: () => {
        return {
            userId: localStorage.getItem('userId'),
            email: localStorage.getItem('userEmail'),
            name: localStorage.getItem('userName'),
            userType: localStorage.getItem('userType'),
        };
    },

    clearLoginData: () => {
        localStorage.removeItem('isLoggedIn');
        localStorage.removeItem('userId');
        localStorage.removeItem('userEmail');
        localStorage.removeItem('userName');
        localStorage.removeItem('userType');
    }
};

// Helper function to prevent right-click on images
const handleRightClick = (e) => {
    e.preventDefault();
    return false;
};

// Helper function to prevent drag start on images
const handleDragStart = (e) => {
    e.preventDefault();
    return false;
};

// Helper function to extract city from address
const extractCity = (photographerData) => {
    if (photographerData.city) {
        return photographerData.city;
    } else if (photographerData.address) {
        // Extract city from address (first part before comma)
        return photographerData.address.split(',')[0].trim();
    } else {
        return 'Location not specified';
    }
};

  




// Helper function to calculate average rating from reviews
const calculateAverageRating = (reviews) => {
    if (!reviews || reviews.length === 0) return '0.0';
    
    const totalRating = reviews.reduce((sum, review) => {
        return sum + (review.rating || 0);
    }, 0);
    
    return (totalRating / reviews.length).toFixed(1);
};

const PORTFOLIO_LOADING_QUOTES = [
    "You don't take a photograph, you make it. — Ansel Adams",
    'Photography is the story I fail to put into words. — Destin Sparks',
    'The best thing about a picture is that it never changes, even when the people in it do. — Andy Warhol',
];

const PhotographerPortfolio = () => {
    const navigate = useNavigate();
    // App.js mounts this component on four routes, and they don't agree on the
    // param name: /photographer/:photographerId vs /PhotographerPortfolio/:id.
    // Reading only `photographerId` left the :id route permanently blank.
    const routeParams = useParams();
    const photographerId = routeParams.photographerId || routeParams.id;
    

     const [email, setEmail] = useState('');

  const handleSubscribe = async (e) => {
    
  e.preventDefault();
  
  if (!email || !/\S+@\S+\.\S+/.test(email)) {
    console.log('Please enter a valid email');
    return;
  }

  try {
    // Save to Firestore 'subscribers' collection
    await addDoc(collection(db, 'subscribers'), {
      email: email,
      subscribedAt: new Date(),
      source: 'landing_page_footer'
    });
    
    console.log('Successfully subscribed!');
    setEmail(''); // Clear input
    // Optional: toast.success('Thank you for subscribing!');
  } catch (error) {
    console.error('Subscription error:', error);
    // Optional: toast.error('Failed to subscribe. Please try again.');
  }
};


    
    // State for photographer data
    const [photographerData, setPhotographerData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [loadingQuote] = useState(
        () => PORTFOLIO_LOADING_QUOTES[Math.floor(Math.random() * PORTFOLIO_LOADING_QUOTES.length)]
    );
    const [albums, setAlbums] = useState([]);
    const [portfolioPhotos, setPortfolioPhotos] = useState([]);
    const [isLoadingAlbums, setIsLoadingAlbums] = useState(true);
    const [selectedAlbum, setSelectedAlbum] = useState(null);
    const [albumPhotos, setAlbumPhotos] = useState([]);
    const [showAlbumModal, setShowAlbumModal] = useState(false);
    const [rating, setRating] = useState(0);
    const [reviewText, setReviewText] = useState('');
    const [relatedPhotographers, setRelatedPhotographers] = useState([]);

    // State for dynamic photo display
    const [currentDisplayPhotos, setCurrentDisplayPhotos] = useState([]);
    const [currentDisplayTitle, setCurrentDisplayTitle] = useState('Portfolio');
    
    // NEW: Loading state for album changes
    const [isChangingAlbumLoading, setIsChangingAlbumLoading] = useState(false);

    // NEW: All Photos Modal States
    const [showAllPhotosModal, setShowAllPhotosModal] = useState(false);
    const [allPhotosData, setAllPhotosData] = useState([]);
    const [allPhotosTitle, setAllPhotosTitle] = useState('');

    // Image Preview Modal States
    const [showImagePreview, setShowImagePreview] = useState(false);
    const [previewImage, setPreviewImage] = useState('');
    const [previewImageIndex, setPreviewImageIndex] = useState(0);
    const [previewImageList, setPreviewImageList] = useState([]);
    const [previewImageTitle, setPreviewImageTitle] = useState('');

    // Authentication state
    const [logged_in, setLogged_in] = useState(false);
    const [userProfile, setUserProfile] = useState(null);
    const [showProfileMenu, setShowProfileMenu] = useState(false);
    const [isNavMenuOpen, setIsNavMenuOpen] = useState(false);
    const [authLoading, setAuthLoading] = useState(true);
    const profileWidgetRef = useRef(null);

    // Mobile sidebar state
    const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);

    // Reviews state
    const [reviews, setReviews] = useState([]);
    const [isLoadingReviews, setIsLoadingReviews] = useState(true);
    const [isSubmittingReview, setIsSubmittingReview] = useState(false);
    const [userHasReviewed, setUserHasReviewed] = useState(false);
    const [hoveredRating, setHoveredRating] = useState(0);

    // Favorites state
    const [isFavorited, setIsFavorited] = useState(false);
    const [isUpdatingFavorite, setIsUpdatingFavorite] = useState(false);

    // UPDATED: Enquiry Modal State with enhanced budget handling
    const [showEnquiryModal, setShowEnquiryModal] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [enquiryForm, setEnquiryForm] = useState({
        location: '',
        preferredDate: new Date(),
        budget: '', // Changed to store custom budget input
        typeOfShoot: '',
        timeOfDay: '',
        message: ''
    });
    const [isSubmittingEnquiry, setIsSubmittingEnquiry] = useState(false);
    const [availableShootTypes, setAvailableShootTypes] = useState([]); // NEW: Dynamic shoot types from photographer's services

    // Description expansion state
    const [isDescriptionExpanded, setIsDescriptionExpanded] = useState(false);
    const [areServicesExpanded, setAreServicesExpanded] = useState(false);


    // UPDATED: Function to extract available shoot types with "Photography" suffix
    const getAvailableShootTypes = useCallback((photographerServices) => {
        if (!photographerServices || Object.keys(photographerServices).length === 0) {
            // Return default options if no services are available
            return [
                { value: 'wedding', label: 'Wedding Photography' },
                { value: 'portrait', label: 'Portrait Photography' },
                { value: 'event', label: 'Event Photography' },
                { value: 'fashion', label: 'Fashion Photography' },
                { value: 'product', label: 'Product Photography' },
                { value: 'corporate', label: 'Corporate Photography' },
                { value: 'nature', label: 'Nature Photography' },
                { value: 'other', label: 'Other' }
            ];
        }

        const serviceTypes = [];
        const serviceKeys = Object.keys(photographerServices);

        // Service mapping with proper "Photography" labels
        const serviceMapping = {
            'Wedding': { value: 'wedding', label: 'Wedding Photography' },
            'Portrait': { value: 'portrait', label: 'Portrait Photography' },
            'Event': { value: 'event', label: 'Event Photography' },
            'Fashion': { value: 'fashion', label: 'Fashion Photography' },
            'Product': { value: 'product', label: 'Product Photography' },
            'Corporate': { value: 'corporate', label: 'Corporate Photography' },
            'Nature': { value: 'nature', label: 'Nature Photography' },
            'Lifestyle': { value: 'lifestyle', label: 'Lifestyle Photography' },
            'Commercial': { value: 'commercial', label: 'Commercial Photography' },
            'Family': { value: 'family', label: 'Family Photography' },
            'Maternity': { value: 'maternity', label: 'Maternity Photography' },
            'Newborn': { value: 'newborn', label: 'Newborn Photography' },
            'Engagement': { value: 'engagement', label: 'Engagement Photography' },
            'Pre-Wedding': { value: 'pre-wedding', label: 'Pre-Wedding Photography' },
            'Birthday': { value: 'birthday', label: 'Birthday Photography' },
            'Anniversary': { value: 'anniversary', label: 'Anniversary Photography' },
            'Sports': { value: 'sports', label: 'Sports Photography' },
            'Headshot': { value: 'headshot', label: 'Headshot Photography' }
        };

        // Add services that the photographer actually offers
        serviceKeys.forEach(serviceKey => {
            const price = photographerServices[serviceKey];
            if (price && price > 0) {
                let finalLabel;
                
                if (serviceMapping[serviceKey]) {
                    // Use predefined mapping
                    finalLabel = serviceMapping[serviceKey].label;
                } else {
                    // For custom service names, ensure proper formatting
                    let cleanServiceKey = serviceKey.trim();
                    
                    // If it already ends with "Photography", keep it as is
                    if (cleanServiceKey.toLowerCase().endsWith('photography')) {
                        finalLabel = cleanServiceKey;
                    } else {
                        // Add "Photography" to the end
                        finalLabel = `${cleanServiceKey} Photography`;
                    }
                }
                
                serviceTypes.push({
                    value: serviceKey.toLowerCase().replace(/\s+/g, '-').replace(/photography/gi, ''),
                    label: finalLabel
                });
            }
        });

        // Remove duplicates based on label
        const uniqueServiceTypes = serviceTypes.filter((service, index, self) => 
            index === self.findIndex(s => s.label === service.label)
        );

        // Always add "Other" as an option
        uniqueServiceTypes.push({ value: 'other', label: 'Other' });

        return uniqueServiceTypes;
    }, []);

    // Mobile screen size detection
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth > 768) {
                setIsMobileSidebarOpen(false);
                document.body.style.overflow = 'unset';
            }
        };
        
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // Mobile sidebar functions
    const toggleMobileSidebar = () => {
        setIsMobileSidebarOpen(!isMobileSidebarOpen);
        if (!isMobileSidebarOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }
    };

    const closeMobileSidebar = () => {
        setIsMobileSidebarOpen(false);
        document.body.style.overflow = 'unset';
    };

    const handleMobileNavClick = (path) => {
        navigate(path);
        closeMobileSidebar();
    };

    // Image Preview Functions
    const openImagePreview = (imageUrl, imageList, index, title = '') => {
        setPreviewImage(imageUrl);
        setPreviewImageList(imageList);
        setPreviewImageIndex(index);
        setPreviewImageTitle(title);
        setShowImagePreview(true);
        document.body.style.overflow = 'hidden';
    };

    const closeImagePreview = () => {
        setShowImagePreview(false);
        setPreviewImage('');
        setPreviewImageList([]);
        setPreviewImageIndex(0);
        setPreviewImageTitle('');
        document.body.style.overflow = 'auto';
    };

    const navigatePreviewImage = (direction) => {
        if (previewImageList.length === 0) return;
        
        let newIndex;
        if (direction === 'next') {
            newIndex = (previewImageIndex + 1) % previewImageList.length;
        } else {
            newIndex = previewImageIndex === 0 ? previewImageList.length - 1 : previewImageIndex - 1;
        }
        
        setPreviewImageIndex(newIndex);
        setPreviewImage(previewImageList[newIndex]);
    };

    // Description functions
    const toggleDescription = () => {
        setIsDescriptionExpanded(!isDescriptionExpanded);
    };

    const isDescriptionLong = (text) => {
        return text && text.length > 150;
    };

    // UPDATED: Album Selection Functions with loading state
    const handleAlbumClick = async (album) => {
        setIsChangingAlbumLoading(true);
        
        // Add a small delay to show the loading animation
        setTimeout(() => {
            setCurrentDisplayPhotos(album.photos || []);
            setCurrentDisplayTitle(album.albumName);
            setIsChangingAlbumLoading(false);
        }, 300); // 300ms delay for smooth loading effect
    };

    const resetToPortfolio = async () => {
        setIsChangingAlbumLoading(true);
        
        // Add a small delay to show the loading animation
        setTimeout(() => {
            setCurrentDisplayPhotos(portfolioPhotos);
            setCurrentDisplayTitle('Portfolio');
            setIsChangingAlbumLoading(false);
        }, 300); // 300ms delay for smooth loading effect
    };

    // UPDATED: Handle keyboard navigation for image preview, sidebar, and all photos modal
    useEffect(() => {
        const handleKeyPress = (e) => {
            if (e.key === 'Escape') {
                if (showImagePreview) {
                    closeImagePreview();
                } else if (showAllPhotosModal) {
                    setShowAllPhotosModal(false);
                    setAllPhotosData([]);
                    setAllPhotosTitle('');
                    document.body.style.overflow = 'auto';
                } else if (isMobileSidebarOpen) {
                    closeMobileSidebar();
                }
                return;
            }
            
            if (showImagePreview) {
                switch (e.key) {
                    case 'ArrowLeft':
                        navigatePreviewImage('prev');
                        break;
                    case 'ArrowRight':
                        navigatePreviewImage('next');
                        break;
                    default:
                        break;
                }
            }
        };

        document.addEventListener('keydown', handleKeyPress);
        return () => {
            document.removeEventListener('keydown', handleKeyPress);
            document.body.style.overflow = 'unset';
        };
    }, [showImagePreview, showAllPhotosModal, previewImageIndex, previewImageList, isMobileSidebarOpen]);

    // Set initial photos when portfolioPhotos loads
    useEffect(() => {
        if (portfolioPhotos.length > 0 && currentDisplayPhotos.length === 0) {
            setCurrentDisplayPhotos(portfolioPhotos);
        }
    }, [portfolioPhotos, currentDisplayPhotos.length]);

    // Helper function to get lowest price
    const getLowestPrice = useCallback((services) => {
        if (!services || Object.keys(services).length === 0) return '25,000';
        
        const prices = Object.values(services).filter(price => price > 0);
        if (prices.length === 0) return '25,000';
        
        const minPrice = Math.min(...prices);
        return minPrice.toLocaleString('en-IN');
    }, []);

    // Get main service category
    const getMainService = useCallback((services) => {
        if (!services || Object.keys(services).length === 0) return 'Photography';
        
        const serviceKeys = Object.keys(services);
        const serviceMap = {
            'Wedding': 'Wedding Photography',
            'Portrait': 'Portrait Photography',
            'Event': 'Event Photography',
            'Fashion': 'Fashion Photography',
            'Product': 'Product Photography',
            'Corporate': 'Corporate Photography',
            'Nature': 'Nature Photography'
        };
        
        for (const key of serviceKeys) {
            if (services[key] > 0 && serviceMap[key]) {
                return serviceMap[key];
            }
        }
        
        return serviceKeys[0] ? `${serviceKeys[0]} Photography` : 'Photography';
    }, []);

    // UPDATED: Enquiry Form Handlers with custom budget input
    const handleEnquiryFormChange = (e) => {
        const { name, value } = e.target;
        
        // Handle budget input with formatting
        if (name === 'budget') {
            // Remove any non-numeric characters except comma and decimal
            const numericValue = value.replace(/[^\d,.-]/g, '');
            setEnquiryForm(prev => ({
                ...prev,
                [name]: numericValue
            }));
        } else {
            setEnquiryForm(prev => ({
                ...prev,
                [name]: value
            }));
        }
    };

    const handleDateChange = (date) => {
        setEnquiryForm(prev => ({
            ...prev,
            preferredDate: date
        }));
    };

    // UPDATED: Handle enquiry submission with custom budget
    const handleEnquirySubmit = async (e) => {
        e.preventDefault();
        
        if (!logged_in || !userProfile) {
            toast.error('Please log in to send an enquiry');
            navigate('/Login');
            return;
        }

        // Validate budget input
        if (!enquiryForm.budget || enquiryForm.budget.trim() === '') {
            toast.error('Please enter your budget range');
            return;
        }

        try {
            setIsSubmittingEnquiry(true);
            
            const enquiryData = {
                userId: userProfile.id,
                userName: userProfile.name,
                userEmail: userProfile.email,
                photographerId: photographerId,
                photographerName: photographerData.name,
                location: enquiryForm.location,
                preferredDate: Timestamp.fromDate(enquiryForm.preferredDate),
                budget: enquiryForm.budget, // Now stores custom budget input
                typeOfShoot: enquiryForm.typeOfShoot,
                timeOfDay: enquiryForm.timeOfDay,
                message: enquiryForm.message,
                status: 'pending',
                createdAt: serverTimestamp()
            };

            const requestsRef = collection(db, 'photographers', photographerId, 'requests');
            await addDoc(requestsRef, enquiryData);

            setShowSuccessModal(true);
            setShowEnquiryModal(false);
            
            setEnquiryForm({
                location: '',
                preferredDate: new Date(),
                budget: '',
                typeOfShoot: '',
                timeOfDay: '',
                message: ''
            });

        } catch (error) {
            console.error('Error sending enquiry:', error);
            toast.error('Error sending enquiry. Please try again.');
        } finally {
            setIsSubmittingEnquiry(false);
        }
    };

    // UPDATED: Close enquiry modal and fetch available shoot types
    const openEnquiryModal = () => {
        // Fetch available shoot types from photographer's services when opening modal
        const shootTypes = getAvailableShootTypes(photographerData?.serviceCategories || photographerData?.services);
        setAvailableShootTypes(shootTypes);
        setShowEnquiryModal(true);
    };

    const closeEnquiryModal = () => {
        setShowEnquiryModal(false);
        setEnquiryForm({
            location: '',
            preferredDate: new Date(),
            budget: '',
            typeOfShoot: '',
            timeOfDay: '',
            message: ''
        });
    };

    // Check if photographer is already favorited
    const checkIfFavorited = useCallback(async (userId, photographerId) => {
        try {
            if (!userId || !photographerId) return false;
            
            const favoriteDocRef = doc(db, 'users', userId, 'favorites', photographerId);
            const favoriteDoc = await getDoc(favoriteDocRef);
            
            return favoriteDoc.exists();
        } catch (error) {
            console.error('Error checking favorite status:', error);
            return false;
        }
    }, []);

    // Add photographer to favorites
    const addToFavorites = async (userId, photographerData) => {
        try {
            setIsUpdatingFavorite(true);
            
            const favoriteData = {
                photographerId: photographerData.id,
                photographerName: photographerData.name,
                profileImage: photographerData.profileImage || 'https://images.pexels.com/photos/1264210/pexels-photo-1264210.jpeg',
                rating: calculateAverageRating(reviews) || 4.5,
                location: photographerData.address || photographerData.city || 'Location not specified',
                startingPrice: photographerData.startingPrice,
                specialization: getMainService(photographerData.services),
                favoritedAt: serverTimestamp()
            };
            
            const favoriteDocRef = doc(db, 'users', userId, 'favorites', photographerData.id);
            await setDoc(favoriteDocRef, favoriteData);
            
            setIsFavorited(true);
            toast.success('Added to favorites!');
            
        } catch (error) {
            console.error('Error adding to favorites:', error);
            toast.error('Error adding to favorites');
        } finally {
            setIsUpdatingFavorite(false);
        }
    };

    // Remove photographer from favorites
    const removeFromFavorites = async (userId, photographerId) => {
        try {
            setIsUpdatingFavorite(true);
            
            const favoriteDocRef = doc(db, 'users', userId, 'favorites', photographerId);
            await deleteDoc(favoriteDocRef);
            
            setIsFavorited(false);
            toast.success('Removed from favorites!');
            
        } catch (error) {
            console.error('Error removing from favorites:', error);
            toast.error('Error removing from favorites');
        } finally {
            setIsUpdatingFavorite(false);
        }
    };

    // Toggle favorite status
    const handleFavoriteToggle = async () => {
        if (!logged_in || !userProfile) {
            toast.error('Please log in to add favorites');
            navigate('/Login');
            return;
        }
        
        if (isUpdatingFavorite) return;
        
        if (isFavorited) {
            await removeFromFavorites(userProfile.id, photographerId);
        } else {
            await addToFavorites(userProfile.id, photographerData);
        }
    };

    // Get album photos from Firebase Storage
    const getAlbumPhotos = useCallback(async (photographerId, albumName) => {
        try {
            const possiblePaths = [
                `photographers/${photographerId}/albums/${albumName}`,
                `photographers/${photographerId}/Albums/${albumName}`,
                `albums/${photographerId}/${albumName}`,
                `Albums/${photographerId}/${albumName}`,
                `${photographerId}/albums/${albumName}`,
                `${photographerId}/Albums/${albumName}`
            ];
            
            for (const path of possiblePaths) {
                try {
                    const albumRef = ref(storage, path);
                    const albumList = await listAll(albumRef);
                    
                    if (albumList.items.length > 0) {
                        const photoUrls = await Promise.all(
                            albumList.items.map(async (item) => {
                                try {
                                    return await getDownloadURL(item);
                                } catch (error) {
                                    console.error('Error getting download URL:', error);
                                    return null;
                                }
                            })
                        );
                        
                        return photoUrls.filter(url => url !== null);
                    }
                } catch (error) {
                    continue;
                }
            }
            
            return [];
            
        } catch (error) {
            console.error('Error getting album photos:', error);
            return [];
        }
    }, []);

    // Get photos from a storage reference
    const getAlbumPhotosFromRef = useCallback(async (albumRef) => {
        try {
            const photosList = await listAll(albumRef);
            const photoUrls = await Promise.all(
                photosList.items.map(async (item) => {
                    try {
                        return await getDownloadURL(item);
                    } catch (error) {
                        console.error('Error getting photo URL:', error);
                        return null;
                    }
                })
            );
            
            return photoUrls.filter(url => url !== null);
        } catch (error) {
            console.error('Error getting album photos from ref:', error);
            return [];
        }
    }, []);

    // Get albums from Firebase Storage structure
    const getAlbumsFromStorage = useCallback(async (photographerId) => {
        try {
            const possibleBasePaths = [
                `photographers/${photographerId}/albums`,
                `photographers/${photographerId}/Albums`,
                `albums/${photographerId}`,
                `Albums/${photographerId}`,
                `${photographerId}/albums`,
                `${photographerId}/Albums`
            ];
            
            for (const basePath of possibleBasePaths) {
                try {
                    const albumsRef = ref(storage, basePath);
                    const albumsList = await listAll(albumsRef);
                    
                    if (albumsList.prefixes.length > 0) {
                        const albumsData = await Promise.all(
                            albumsList.prefixes.map(async (albumRef, index) => {
                                const albumName = albumRef.name;
                                const photos = await getAlbumPhotosFromRef(albumRef);
                                
                                return {
                                    id: `storage_album_${index}`,
                                    albumName: albumName.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase()),
                                    description: `${albumName} photography collection`,
                                    location: 'Professional Shoot',
                                    coverImage: photos[0] || 'https://images.pexels.com/photos/1264210/pexels-photo-1264210.jpeg',
                                    photoCount: photos.length,
                                    category: 'Portfolio',
                                    photos: photos
                                };
                            })
                        );
                        
                        return albumsData;
                    }
                } catch (error) {
                    continue;
                }
            }
            
            return [];
        } catch (error) {
            console.error('Error getting albums from storage:', error);
            return [];
        }
    }, [getAlbumPhotosFromRef]);

    // Load photographer's albums from Firebase
    const loadPhotographerAlbums = useCallback(async (photographerId) => {
        try {
            setIsLoadingAlbums(true);
            
            const albumsQuery = query(
                collection(db, 'albums'),
                where('photographerId', '==', photographerId)
            );
            
            const albumSnapshot = await getDocs(albumsQuery);
            const customAlbums = [];
            let portfolioPhotos = [];
            
            if (!albumSnapshot.empty) {
                for (const albumDoc of albumSnapshot.docs) {
                    const albumData = albumDoc.data();
                    const albumName = albumData.albumName || albumDoc.id;
                    
                    const photos = await getAlbumPhotos(photographerId, albumName);
                    
                    if (albumName.toLowerCase() === 'portfolio' || 
                        albumData.isDefault === true || 
                        albumData.type === 'portfolio') {
                        portfolioPhotos = photos;
                    } else {
                        customAlbums.push({
                            id: albumDoc.id,
                            albumName: albumName,
                            description: albumData.description || 'Photography collection',
                            location: albumData.location || 'Various locations',
                            createdAt: albumData.createdAt,
                            coverImage: albumData.coverImage || photos[0] || 'https://images.pexels.com/photos/1264210/pexels-photo-1264210.jpeg',
                            photoCount: photos.length,
                            category: albumData.category || 'General',
                            photos: photos
                        });
                    }
                }
            } else {
                const photographerDoc = await getDoc(doc(db, 'photographers', photographerId));
                
                if (photographerDoc.exists()) {
                    const photographerData = photographerDoc.data();
                    const photographerAlbums = photographerData.albums || [];
                    
                    for (const album of photographerAlbums) {
                        const photos = await getAlbumPhotos(photographerId, album.albumName);
                        
                        if (album.albumName?.toLowerCase() === 'portfolio' || 
                            album.isDefault === true) {
                            portfolioPhotos = photos;
                        } else {
                            customAlbums.push({
                                id: album.albumName || `album_${customAlbums.length}`,
                                albumName: album.albumName || album.title || 'Untitled Album',
                                description: album.description || 'Photography collection',
                                location: album.location || 'Various locations',
                                createdAt: album.createdAt,
                                coverImage: album.coverImage || photos[0] || 'https://images.pexels.com/photos/1264210/pexels-photo-1264210.jpeg',
                                photoCount: photos.length,
                                category: album.category || 'General',
                                photos: photos
                            });
                        }
                    }
                }
            }
            
            if (portfolioPhotos.length === 0) {
                portfolioPhotos = await getAlbumPhotos(photographerId, 'Portfolio') || 
                                 await getAlbumPhotos(photographerId, 'portfolio');
            }
            
            if (customAlbums.length === 0) {
                const storageAlbums = await getAlbumsFromStorage(photographerId);
                const filteredStorageAlbums = storageAlbums.filter(album => 
                    album.albumName.toLowerCase() !== 'portfolio'
                );
                customAlbums.push(...filteredStorageAlbums);
            }
            
            setAlbums(customAlbums);
            setPortfolioPhotos(portfolioPhotos);
            
        } catch (error) {
            console.error('Error loading albums:', error);
            setAlbums([]);
            setPortfolioPhotos([]);
        } finally {
            setIsLoadingAlbums(false);
        }
    }, [getAlbumPhotos, getAlbumsFromStorage]);

    // Load related photographers
    const loadRelatedPhotographers = useCallback(async (location) => {
        try {
            const q = query(
                collection(db, 'photographers'),
                where('address', '==', location),
                limit(4)
            );
            const querySnapshot = await getDocs(q);
            const related = [];
            
            querySnapshot.forEach((doc) => {
                if (doc.id !== photographerId) {
                    const data = doc.data();
                    related.push({
                        id: doc.id,
                        name: data.name,
                        location: data.address || data.city,
                        price: getLowestPrice(data.serviceableCategoriesWithPrices || data.serviceCategories || {}),
                        rating: data.rating || 4.5,
                        image: data.profileImage || 'https://images.pexels.com/photos/1264210/pexels-photo-1264210.jpeg'
                    });
                }
            });
            
            setRelatedPhotographers(related);
        } catch (error) {
            console.error('Error loading related photographers:', error);
        }
    }, [photographerId, getLowestPrice]);

    // Load reviews from Firebase
    const loadReviews = useCallback(async (photographerId) => {
        try {
            setIsLoadingReviews(true);

            const reviewsQuery = query(
                collection(db, 'reviews', photographerId, 'reviews'),
                orderBy('createdAt', 'desc')
            );

            const reviewsSnapshot = await getDocs(reviewsQuery);
            const reviewsData = [];

            reviewsSnapshot.forEach((doc) => {
                const reviewData = doc.data();
                reviewsData.push({
                    id: doc.id,
                    ...reviewData,
                    createdAt: reviewData.createdAt?.toDate() || new Date()
                });
            });

            setReviews(reviewsData);

            if (userProfile?.id) {
                const userReview = reviewsData.find(review => review.userId === userProfile.id);
                setUserHasReviewed(!!userReview);
            }

        } catch (error) {
            console.error('Error loading reviews:', error);
            setReviews([]);
        } finally {
            setIsLoadingReviews(false);
        }
    }, [userProfile?.id]);

    // Submit review to Firebase
    const handleReviewSubmit = async (e) => {
        e.preventDefault();

        if (!logged_in || !userProfile) {
            toast.error('Please log in to submit a review');
            navigate('/Login');
            return;
        }

        if (rating === 0 || rating < 1 || rating > 5) {
            toast.error('Please select a rating between 1-5 stars');
            return;
        }

        if (!reviewText.trim()) {
            toast.error('Please write a review');
            return;
        }

        if (userHasReviewed) {
            toast.error('You have already reviewed this photographer');
            return;
        }

        try {
            setIsSubmittingReview(true);

            const reviewData = {
                userId: userProfile.id,
                userName: userProfile.name,
                userEmail: userProfile.email,
                rating: Number(rating),
                reviewText: reviewText.trim(),
                createdAt: serverTimestamp()
            };

            const reviewsSubcollectionRef = collection(db, 'reviews', photographerId, 'reviews');
            const reviewRef = await addDoc(reviewsSubcollectionRef, reviewData);

            // Update photographer's rating with calculated average
            const newReviewsArray = [...reviews, { ...reviewData, rating: Number(rating) }];
            const newAverageRating = calculateAverageRating(newReviewsArray);

            const photographerRef = doc(db, 'photographers', photographerId);
            await updateDoc(photographerRef, {
                rating: parseFloat(newAverageRating),
                reviewsCount: increment(1)
            });

            setPhotographerData(prev => ({
                ...prev,
                rating: parseFloat(newAverageRating),
                reviewsCount: newReviewsArray.length
            }));

            setRating(0);
            setReviewText('');
            setHoveredRating(0);
            setUserHasReviewed(true);

            await loadReviews(photographerId);

            toast.success('Review submitted successfully!');

        } catch (error) {
            console.error('Error submitting review:', error);
            toast.error('Error submitting review. Please try again.');
        } finally {
            setIsSubmittingReview(false);
        }
    };

    const handleStarClick = (starValue) => {
        setRating(starValue);
    };

    const handleStarHover = (starValue) => {
        setHoveredRating(starValue);
    };

    const handleStarLeave = () => {
        setHoveredRating(0);
    };

    // Enhanced star rendering with hover effects
    const renderInteractiveStars = (currentRating, isInteractive = false) => {
        const stars = [];
        const displayRating = hoveredRating || currentRating;
        
        for (let i = 1; i <= 5; i++) {
            const isFilled = i <= displayRating;
            const isHovered = hoveredRating > 0 && i <= hoveredRating;
            
            stars.push(
                <svg
                    key={i}
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    aria-hidden="true"
                    className={`pp-star ${isFilled || isHovered ? 'is-filled' : ''} ${isInteractive ? 'is-interactive' : ''}`}
                    onClick={isInteractive ? () => handleStarClick(i) : undefined}
                    onMouseEnter={isInteractive ? () => handleStarHover(i) : undefined}
                    onMouseLeave={isInteractive ? handleStarLeave : undefined}
                >
                    <path d="m12 2 2.9 6.3 6.8.8-5 4.7 1.3 6.7-6-3.4-6 3.4 1.3-6.7-5-4.7 6.8-.8Z" />
                </svg>
            );
        }
        
        return stars;
    };

    // Format review date
    const formatReviewDate = (date) => {
        if (!date) return 'Recently';
        
        const now = new Date();
        const reviewDate = date instanceof Date ? date : new Date(date);
        const diffInHours = Math.floor((now - reviewDate) / (1000 * 60 * 60));
        
        if (diffInHours < 1) return 'Just now';
        if (diffInHours < 24) return `${diffInHours} hours ago`;
        if (diffInHours < 48) return 'Yesterday';
        if (diffInHours < 168) return `${Math.floor(diffInHours / 24)} days ago`;
        
        return reviewDate.toLocaleDateString();
    };

    const renderStars = (currentRating) => {
        // Use calculated rating instead of stored rating
        const avgRating = parseFloat(calculateAverageRating(reviews));
        return Array.from({ length: 5 }, (_, index) => (
            <svg
                key={index}
                viewBox="0 0 24 24"
                fill="currentColor"
                aria-hidden="true"
                className={`pp-star ${index < avgRating ? 'is-filled' : ''}`}
            >
                <path d="m12 2 2.9 6.3 6.8.8-5 4.7 1.3 6.7-6-3.4-6 3.4 1.3-6.7-5-4.7 6.8-.8Z" />
            </svg>
        ));
    };

    // Firebase Authentication Check
    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, async (user) => {
            setAuthLoading(true);
            
            if (user) {
                try {
                    const loginData = LocalStorageHelper.getLoginData();
                    let userType = loginData.userType || 'user';
                    
                    let userDocRef = doc(db, userType === 'vendor' || userType === 'photographer' ? 'photographers' : 'users', user.uid);
                    let userDoc = await getDoc(userDocRef);
                    
                    if (!userDoc.exists()) {
                        userType = userType === 'vendor' || userType === 'photographer' ? 'user' : 'photographer';
                        userDocRef = doc(db, userType === 'photographer' ? 'photographers' : 'users', user.uid);
                        userDoc = await getDoc(userDocRef);
                        
                        if (userDoc.exists()) {
                            LocalStorageHelper.saveLoginData(
                                user.uid,
                                user.email,
                                user.displayName || "User",
                                userType
                            );
                        }
                    }
                    
                    if (userDoc.exists()) {
                        const userData = userDoc.data();
                        
                        const getAvatarUrl = (userData, user) => {
                            const avatarSources = [
                                userData.profileImage,
                                userData.avatarUrl,
                                userData.avatar,
                                user.photoURL
                            ];
                            
                            const validAvatar = avatarSources.find(url => url && url.trim() !== '' && url !== 'undefined');
                            
                            if (validAvatar) {
                                return validAvatar;
                            }
                            
                            const name = userData.name || user.displayName || "User";
                            return `https://ui-avatars.com/api/?name=${encodeURIComponent(name)}&background=6366f1&color=fff&size=128&bold=true&font-size=0.6`;
                        };
                        
                        const profileData = {
                            id: user.uid,
                            name: userData.name || user.displayName || "User",
                            email: userData.email || user.email,
                            avatar: getAvatarUrl(userData, user),
                            role: userType,
                            joinDate: userData.createdAt,
                            isVerified: user.emailVerified || userData.emailVerified || false,
                            userType: userType
                        };
                        
                        setUserProfile(profileData);
                        setLogged_in(true);
                        
                        LocalStorageHelper.saveLoginData(
                            user.uid,
                            userData.email || user.email,
                            userData.name || user.displayName || "User",
                            userType
                        );
                        
                    } else {
                        const basicProfile = {
                            id: user.uid,
                            name: user.displayName || "User",
                            email: user.email,
                            userType: 'user',
                            avatar: `https://ui-avatars.com/api/?name=${encodeURIComponent(user.displayName || 'User')}&background=6366f1&color=fff&size=128&bold=true&font-size=0.6`,
                            isVerified: user.emailVerified || false
                        };
                        
                        setUserProfile(basicProfile);
                        setLogged_in(true);
                        
                        LocalStorageHelper.saveLoginData(
                            user.uid,
                            user.email,
                            user.displayName || "User",
                            'user'
                        );
                    }
                } catch (error) {
                    console.error('Error fetching user data:', error);
                    const basicProfile = {
                        id: user.uid,
                        name: user.displayName || "User",
                        email: user.email,
                        userType: 'user',
                        avatar: `https://ui-avatars.com/api/?name=${encodeURIComponent(user.displayName || 'User')}&background=6366f1&color=fff&size=128&bold=true&font-size=0.6`,
                        isVerified: user.emailVerified || false
                    };
                    
                    setUserProfile(basicProfile);
                    setLogged_in(true);
                }
            } else {
                setLogged_in(false);
                setUserProfile(null);
                LocalStorageHelper.clearLoginData();
            }
            
            setAuthLoading(false);
        });

        return () => unsubscribe();
    }, []);

    // Load photographer data from Firebase
    useEffect(() => {
        const loadPhotographerData = async () => {
            if (!photographerId) return;
            
            setIsLoading(true);
            try {
                const docRef = doc(db, 'photographers', photographerId);
                const docSnap = await getDoc(docRef);
                
                if (docSnap.exists()) {
                    const data = docSnap.data();
                    setPhotographerData({
                        id: docSnap.id,
                        ...data,
                        services: data.serviceableCategoriesWithPrices || data.serviceCategories || {},
                        startingPrice: getLowestPrice(data.serviceableCategoriesWithPrices || data.serviceCategories || {}),
                        reviews: data.reviews || [],
                        rating: data.rating || 4.5,
                        reviewsCount: data.reviewsCount || 0,
                        yearsExperience: data.yearsExperience || 1,
                        completedProjects: data.completedProjects || 0,
                        specialties: data.specialties || [],
                        policies: data.policies || {
                            cancellationPolicy: '',
                            paymentTerms: '',
                            travelCostBearer: '',
                            deliveryTime: ''
                        },
                        professionalDetails: data.professionalDetails || {
                            workLocation: '',
                            proficientPosing: false,
                            completedProjects: 0
                        },
                        serviceAreas: data.serviceAreas || data.serviceableAreas || [],
                        serviceCategories: data.serviceCategories || data.serviceableCategoriesWithPrices || {},
                        features: data.features || []
                    });
                    
                    await loadPhotographerAlbums(photographerId);
                    await loadRelatedPhotographers(data.address || data.city);
                    await loadReviews(photographerId);
                } else {
                    toast.error('Photographer not found');
                    navigate('/BrowsePhotographer');
                }
            } catch (error) {
                console.error('Error loading photographer:', error);
                toast.error('Error loading photographer data');
            } finally {
                setIsLoading(false);
            }
        };

        loadPhotographerData();
    }, [photographerId, navigate, getLowestPrice, loadPhotographerAlbums, loadRelatedPhotographers, loadReviews]);

    // Check favorite status when user profile changes
    useEffect(() => {
        const checkFavoriteStatus = async () => {
            if (logged_in && userProfile && photographerId) {
                const favorited = await checkIfFavorited(userProfile.id, photographerId);
                setIsFavorited(favorited);
            }
        };
        
        checkFavoriteStatus();
    }, [logged_in, userProfile, photographerId, checkIfFavorited]);

    // Reload reviews when user profile changes
    useEffect(() => {
        if (photographerId && userProfile) {
            loadReviews(photographerId);
        }
    }, [photographerId, userProfile, loadReviews]);

    // Enhanced Logout Handler
    const handleLogout = useCallback(async () => {
        try {
            await signOut(auth);
            LocalStorageHelper.clearLoginData();
            
            setLogged_in(false);
            setUserProfile(null);
            setShowProfileMenu(false);
            closeMobileSidebar();
        } catch (error) {
            console.error('Error logging out:', error);
        }
    }, []);

    // Profile handlers
    const handleProfileClick = () => {
        setShowProfileMenu(false);
        closeMobileSidebar();

        if (userProfile?.userType === 'vendor' || userProfile?.userType === 'photographer') {
            navigate('/Dashboard');
        } else {
            navigate('/ProfileSettings');
        }
    };

    const handleSettingsClick = () => {
        setShowProfileMenu(false);
        closeMobileSidebar();
        navigate('/ProfileSettings');
    };

    const handleMyBookingsClick = () => {
        setShowProfileMenu(false);
        closeMobileSidebar();
        navigate('/UserBookings');
    };
const [showTerms, setShowTerms] = useState(false);
const [showPrivacy, setShowPrivacy] = useState(false);
const [showCookie, setShowCookie] = useState(false);
    // Close profile menu when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (profileWidgetRef.current && !profileWidgetRef.current.contains(event.target)) {
                setShowProfileMenu(false);
            }
        };

        if (showProfileMenu) {
            document.addEventListener('mousedown', handleClickOutside);
            return () => document.removeEventListener('mousedown', handleClickOutside);
        }
    }, [showProfileMenu]);

    // Close album modal (keeping for compatibility)
    const closeAlbumModal = () => {
        setShowAlbumModal(false);
        setSelectedAlbum(null);
        setAlbumPhotos([]);
    };

    // Loading state
    if (isLoading) {
        return (
            <div className="photo-profile">
                <div className="pp-loading-screen">
                    <div className="pp-loading-spinner" aria-hidden="true"></div>
                    <p className="pp-loading-quote">&ldquo;{loadingQuote}&rdquo;</p>
                    <p className="pp-loading-status">Loading photographer profile…</p>
                </div>
            </div>
        );
    }
    

    // Error state
    if (!photographerData) {
        return (
            <div className="error-container">
                <h2>Photographer not found</h2>
                <button onClick={() => navigate('/BrowsePhotographer')}>
                    Back to Browse
                </button>
            </div>
        );
    }

    return (
        <>
            {/* The FontAwesome CDN <link> that used to sit here has been removed:
                ~100 KB of CSS + webfonts fetched on every portfolio view to draw
                26 icons. They are inline SVG now, matching the rest of the site. */}
            <div className="photo-profile">
                    {/* Single top nav. Desktop links and the mobile sheet are the
                        same markup switched by CSS media query — the previous
                        isMobile branch read window.innerWidth at mount and could
                        render the wrong nav entirely. */}
                    <div className="top-nav">
                        <div className="nav-left">
                            <button type="button" className="logo-link" onClick={() => navigate("/LandingPage")}>
                                <img src={logo} alt="LitStudio" className="logo-image" onContextMenu={handleRightClick} onDragStart={handleDragStart} />
                            </button>
                            <nav className="nav-links">
                                <button type="button" className="nav-link" onClick={() => navigate("/BrowsePhotographer")}>Browse Photographers</button>
                                <button type="button" className="nav-link" onClick={() => navigate("/AboutUs")}>About</button>
                            </nav>
                        </div>
                        <div className="nav-right">
                            {logged_in && userProfile ? (
                                <div className="profile-menu" ref={profileWidgetRef}>
                                    <button type="button" className="profile-trigger" onClick={() => setShowProfileMenu(!showProfileMenu)}>
                                        <img src={userProfile.avatar} alt={userProfile.name} className="profile-avatar" onContextMenu={handleRightClick} onDragStart={handleDragStart} />
                                        <span className="profile-info-desktop">
                                            <span className="profile-name">{userProfile.name}</span>
                                            <span className="profile-role">{(userProfile.userType === "photographer" || userProfile.userType === "vendor") ? "Photographer" : "User"}</span>
                                        </span>
                                    </button>
                                    {showProfileMenu && (
                                        <div className="profile-dropdown">
                                            <div className="profile-info">
                                                <span>{userProfile.name}</span>
                                                <span className="profile-email">{userProfile.email}</span>
                                            </div>
                                            <button type="button" onClick={handleLogout}>Log out</button>
                                        </div>
                                    )}
                                </div>
                            ) : (
                                <>
                                    <button type="button" className="btn-secondary" onClick={() => navigate("/Login")}>Log In</button>
                                    <button type="button" className="btn-primary" onClick={() => navigate("/CreateAccount")}>Sign Up</button>
                                </>
                            )}
                            <button
                                type="button"
                                className={`pp-hamburger ${isNavMenuOpen ? 'active' : ''}`}
                                onClick={() => setIsNavMenuOpen(!isNavMenuOpen)}
                                aria-label="Toggle navigation menu"
                                aria-expanded={isNavMenuOpen}
                            >
                                <span></span>
                                <span></span>
                                <span></span>
                            </button>
                        </div>
                    </div>

                    {/* Mobile nav — .nav-links is display:none below 760px, so
                        without this Browse/About were unreachable on a phone. */}
                    <div className={`pp-mobile-menu ${isNavMenuOpen ? 'active' : ''}`}>
                        <button type="button" className="pp-mobile-nav-link" onClick={() => { setIsNavMenuOpen(false); navigate("/BrowsePhotographer"); }}>Browse Photographers</button>
                        <button type="button" className="pp-mobile-nav-link" onClick={() => { setIsNavMenuOpen(false); navigate("/AboutUs"); }}>About</button>
                    </div>
                {/* Header */}
                <div className="header">
                    <div className="header-background">
                        <img
                            alt="Header background"
                            className="header-image"
                            src={photographerData.coverImage || photographerData.profileImage || 'https://images.pexels.com/photos/1264210/pexels-photo-1264210.jpeg'}
                            onError={(e) => {
                                e.target.src = 'https://images.pexels.com/photos/1264210/pexels-photo-1264210.jpeg';
                            }}
                            onContextMenu={handleRightClick}
                            onDragStart={handleDragStart}
                        />
                        <div className="header-overlay"></div>
                    </div>
                </div>
                
                {/* Main Content Layout */}
                <div className="main-content">
                    {/* Photographer Sidebar */}
                    <div className="photographer-sidebar">
                        {/* Profile Image and Basic Info with Studio Details */}
                        <div className="sidebar-profile-info">
                            <img
                                alt="Profile"
                                className="sidebar-profile-image"
                                src={photographerData.profileImage || 'https://images.pexels.com/photos/1264210/pexels-photo-1264210.jpeg'}
                                onError={(e) => {
                                    e.target.src = 'https://images.pexels.com/photos/1264210/pexels-photo-1264210.jpeg';
                                }}
                                onContextMenu={handleRightClick}
                                onDragStart={handleDragStart}
                            />
                            <div className="sidebar-profile-rating">
                                {renderStars()}
                                <span>({reviews.length} reviews)</span>
                            </div>
                            
                            {/* Studio Details Section */}
                            <div className="sidebar-profile-details">
                                <div className="sidebar-studio-name">
                                    {photographerData.name}
                                </div>
                                <div className="sidebar-location">
                                    {extractCity(photographerData)}
                                </div>
                                <div className="sidebar-price">
                                    <svg className="pp-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M6 3h12M6 8h12M15 3c0 5-3 5-9 5l9 13"/></svg>
                                    Starting from ₹{photographerData.startingPrice}
                                </div>
                            </div>
                        </div>

                        {/* Action buttons. Send Enquiry opens the photographer-scoped
                            modal, which writes to photographers/{id}/requests — the
                            path PhotographerRequests.js reads. */}
                        <div className="profile-actions">
                            <button 
                                className={`btn-follow ${isFavorited ? 'favorited' : ''}`}
                                onClick={handleFavoriteToggle}
                                disabled={isUpdatingFavorite}
                            >
                                <svg
                                    className="pp-icon"
                                    viewBox="0 0 24 24"
                                    fill={isFavorited ? 'currentColor' : 'none'}
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    aria-hidden="true"
                                >
                                    <path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1-1.1a5.5 5.5 0 0 0-7.8 7.8l1.1 1L12 21.2l7.7-7.7 1.1-1a5.5 5.5 0 0 0 0-7.8Z" />
                                </svg>
                                {isFavorited ? 'Favorited' : 'Add to Favorites'}
                            </button>
                            <button
                                type="button"
                                className="btn-message"
                                onClick={openEnquiryModal}
                            >
                                <svg className="pp-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                                    <rect x="2" y="4" width="20" height="16" rx="2" />
                                    <path d="m2 7 10 6 10-6" />
                                </svg>
                                Send Enquiry
                            </button>
                        </div>

                        {/* About Section */}
                        <div className="sidebar-section">
                            <div className="sidebar-section-title">
                                <svg className="pp-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
                                About
                            </div>
                            <div className={`sidebar-about-description ${isDescriptionExpanded ? 'expanded' : 'collapsed'}`}>
                                {photographerData.description || 
                                `${photographerData.name} is an accomplished photographer with ${photographerData.yearsExperience}+ years of experience, 
                                specializing in ${getMainService(photographerData.services).toLowerCase()}. With a keen eye for detail and a creative approach, 
                                ${photographerData.name} captures moments that blend emotion, elegance, and style.`}
                            </div>
                            {isDescriptionLong(photographerData.description || 
                                `${photographerData.name} is an accomplished photographer with ${photographerData.yearsExperience}+ years of experience, 
                                specializing in ${getMainService(photographerData.services).toLowerCase()}. With a keen eye for detail and a creative approach, 
                                ${photographerData.name} captures moments that blend emotion, elegance, and style.`) && (
                                <button 
                                    className="see-more-btn"
                                    onClick={toggleDescription}
                                >
                                    {isDescriptionExpanded ? 'See Less' : 'See More'}
                                </button>
                            )}
                        </div>

                        {/* Stats - Fixed Rating Display */}
                        <div className="sidebar-section">
                            <div className="sidebar-section-title">
                                <svg className="pp-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><line x1="4" y1="20" x2="4" y2="11"/><line x1="10" y1="20" x2="10" y2="4"/><line x1="16" y1="20" x2="16" y2="14"/><line x1="22" y1="20" x2="2" y2="20"/></svg>
                                Stats
                            </div>
                            <div className="sidebar-stats">
                                <div className="sidebar-stat-item">
                                    <h4>{photographerData.yearsExperience || 1}+</h4>
                                    <p>Years Experience</p>
                                </div>
                                <div className="sidebar-stat-item">
                                    <h4>{albums.length}</h4>
                                    <p>Albums</p>
                                </div>
                                <div className="sidebar-stat-item">
                                    <h4>{calculateAverageRating(reviews)}</h4>
                                    <p>Average Rating</p>
                                </div>
                            </div>
                        </div>

                        {/* Services */}
                        {photographerData.serviceCategories && Object.keys(photographerData.serviceCategories).length > 0 && (
                            <div className="sidebar-section">
                                <div className="sidebar-section-title">
                                    <svg className="pp-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3Z"/><circle cx="12" cy="13" r="3.5"/></svg>
                                    Services
                                </div>
                                {(() => {
                                    const activeServices = Object.keys(photographerData.serviceCategories).filter(service =>
                                        service.trim() !== '' && photographerData.serviceCategories[service] > 0
                                    );
                                    // Long service lists dominated the mobile page (24 pills, one
                                    // per row). Show a preview and let the rest expand on demand.
                                    const PREVIEW_COUNT = 8;
                                    const isTruncatable = activeServices.length > PREVIEW_COUNT;
                                    const visibleServices = (isTruncatable && !areServicesExpanded)
                                        ? activeServices.slice(0, PREVIEW_COUNT)
                                        : activeServices;

                                    return (
                                        <>
                                            <div className="sidebar-services">
                                                <div className="service-tags">
                                                    {visibleServices.map((service, index) => (
                                                        <span key={index} className="service-tag">
                                                            <span className="service-name">{service}</span>
                                                            <span className="service-price">₹{photographerData.serviceCategories[service].toLocaleString('en-IN')}</span>
                                                        </span>
                                                    ))}
                                                </div>
                                            </div>
                                            {isTruncatable && (
                                                <button
                                                    className="see-more-btn"
                                                    onClick={() => setAreServicesExpanded(!areServicesExpanded)}
                                                >
                                                    {areServicesExpanded
                                                        ? 'Show fewer services'
                                                        : `Show all ${activeServices.length} services`}
                                                </button>
                                            )}
                                        </>
                                    );
                                })()}
                            </div>
                        )}

                        {/* Business Policies */}
                        <div className="sidebar-section">
                            <div className="sidebar-section-title">
                                <svg className="pp-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8Z"/><path d="M14 2v6h6M9 13h6M9 17h4"/></svg>
                                Policies
                            </div>
                            <div className="sidebar-policies">
                                <div className="sidebar-policy-item">
                                    <h5>Cancellation Policy</h5>
                                    <p>{photographerData.policies?.cancellationPolicy || 'Cancellation allowed up to 24 hours before the event.'}</p>
                                </div>
                                <div className="sidebar-policy-item">
                                    <h5>Payment Terms</h5>
                                    <p>{photographerData.policies?.paymentTerms || '30% advance payment required to confirm booking.'}</p>
                                </div>
                                <div className="sidebar-policy-item">
                                    <h5>Delivery Time</h5>
                                    <p>{photographerData.policies?.deliveryTime || 'Edited photos delivered within 7-10 working days.'}</p>
                                </div>
                            </div>
                        </div>

                        {/* Reviews Section */}
                        <div className="sidebar-section">
                            <div className="sidebar-section-title">
                                <svg className="pp-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="m12 2 2.9 6.3 6.8.8-5 4.7 1.3 6.7-6-3.4-6 3.4 1.3-6.7-5-4.7 6.8-.8Z"/></svg>
                                Reviews ({reviews.length})
                            </div>
                            {isLoadingReviews ? (
                                <div className="loading-reviews">
                                    <p>Loading reviews...</p>
                                </div>
                            ) : (
                                <>
                                    <div className="sidebar-reviews">
                                        {reviews.length > 0 ? (
                                            reviews.slice(0, 3).map((review) => (
                                                <div key={review.id} className="sidebar-review-item">
                                                    <div className="sidebar-review-header">
                                                        <h5>{review.userName}</h5>
                                                        <div className="sidebar-review-rating">
                                                            {Array.from({ length: 5 }, (_, index) => (
                                                                <svg
                                                                    key={index}
                                                                    viewBox="0 0 24 24"
                                                                    fill="currentColor"
                                                                    aria-hidden="true"
                                                                    className={`pp-star ${index < review.rating ? 'is-filled' : ''}`}
                                                                >
                                                                    <path d="m12 2 2.9 6.3 6.8.8-5 4.7 1.3 6.7-6-3.4-6 3.4 1.3-6.7-5-4.7 6.8-.8Z" />
                                                                </svg>
                                                            ))}
                                                        </div>
                                                    </div>
                                                    <p className="sidebar-review-text">{review.reviewText}</p>
                                                </div>
                                            ))
                                        ) : (
                                            <p style={{fontSize: '12px', color: '#6b7280', textAlign: 'center'}}>No reviews yet</p>
                                        )}
                                    </div>
                                    
                                    {/* Write Review Form */}
                                    {!logged_in ? (
                                        <div style={{textAlign: 'center', marginTop: '15px'}}>
                                            <button 
                                                className="btn-primary"
                                                style={{width: '100%', fontSize: '12px', padding: '8px'}}
                                                onClick={() => navigate('/Login')}
                                            >
                                                Log In to Review
                                            </button>
                                        </div>
                                    ) : !userHasReviewed ? (
                                        <div className="sidebar-write-review">
                                            <form onSubmit={handleReviewSubmit} className="sidebar-review-form">
                                                <div className="sidebar-rating-input">
                                                    <label>Rating:</label>
                                                    <div className="sidebar-stars-input">
                                                        {renderInteractiveStars(rating, true)}
                                                    </div>
                                                </div>
                                                <textarea 
                                                    className="sidebar-review-textarea"
                                                    placeholder="Write your review..."
                                                    value={reviewText}
                                                    onChange={(e) => setReviewText(e.target.value)}
                                                    required
                                                    maxLength={200}
                                                />
                                                <button 
                                                    type="submit" 
                                                    className="btn-primary"
                                                    style={{width: '100%', fontSize: '12px', padding: '8px'}}
                                                    disabled={isSubmittingReview || rating === 0 || !reviewText.trim()}
                                                >
                                                    {isSubmittingReview ? 'Submitting...' : 'Submit Review'}
                                                </button>
                                            </form>
                                        </div>
                                    ) : (
                                        <p style={{fontSize: '12px', color: '#059669', textAlign: 'center', marginTop: '10px'}}>
                                            ✓ You have reviewed this photographer
                                        </p>
                                    )}
                                </>
                            )}
                        </div>
                    </div>

                    {/* Portfolio Content */}
                    <div className="portfolio-content">
                        <div className="center-header">
                            <h1>Portfolio</h1>
                        </div>

                        <div className="tabs-nav">
                            <a href="#work" className="tab-link active">Portfolio</a>
                        </div>

                        <div className="work-gallery" id="work">
                            {isLoadingAlbums ? (
                                <div className="loading-albums">
                                    <div className="loading-spinner"></div>
                                    <p>Loading portfolio...</p>
                                </div>
                            ) : (
                                <>
                                    {/* Album filter rail. Albums used to render as large
                                        cover cards that pushed the actual work below the
                                        fold; as chips the photographs lead. */}
                                    {(albums.length > 0 || portfolioPhotos.length > 0) && (
                                        <div className="albums-grid" role="tablist" aria-label="Albums">
                                            {portfolioPhotos.length > 0 && (
                                                <button
                                                    type="button"
                                                    role="tab"
                                                    aria-selected={currentDisplayTitle === 'Portfolio'}
                                                    className={`album-chip ${currentDisplayTitle === 'Portfolio' ? 'is-active' : ''}`}
                                                    onClick={resetToPortfolio}
                                                >
                                                    All work
                                                    <span className="album-chip-count">{portfolioPhotos.length}</span>
                                                </button>
                                            )}

                                            {albums.map((album) => (
                                                <button
                                                    key={album.id}
                                                    type="button"
                                                    role="tab"
                                                    aria-selected={currentDisplayTitle === album.albumName}
                                                    className={`album-chip ${currentDisplayTitle === album.albumName ? 'is-active' : ''}`}
                                                    onClick={() => handleAlbumClick(album)}
                                                >
                                                    {album.albumName}
                                                    <span className="album-chip-count">{album.photoCount}</span>
                                                </button>
                                            ))}
                                        </div>
                                    )}
                                    
                                    <div className="portfolio-photos-section">
                                        <div className="portfolio-header">
                                            <h2>{currentDisplayTitle === 'Portfolio' ? 'Selected work' : currentDisplayTitle}</h2>
                                            {currentDisplayPhotos.length > 0 && (
                                                <span className="portfolio-count">
                                                    {currentDisplayPhotos.length}
                                                    {currentDisplayPhotos.length === 1 ? ' photo' : ' photos'}
                                                </span>
                                            )}
                                            {currentDisplayTitle !== 'Portfolio' && (
                                                <button 
                                                    className="back-to-portfolio-btn"
                                                    onClick={resetToPortfolio}
                                                >
                                                    <svg className="pp-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/></svg>
                                                    Back to Portfolio
                                                </button>
                                            )}
                                        </div>
                                        
                                        {/* Loading Bar for Album Changes */}
                                        {isChangingAlbumLoading ? (
                                            <div className="album-loading-container">
                                                <div className="album-loading-bar">
                                                    <div className="album-loading-progress"></div>
                                                </div>
                                                <p className="album-loading-text">Loading {currentDisplayTitle} photos...</p>
                                            </div>
                                        ) : (
                                            <div className="portfolio-photos-grid">
                                                {currentDisplayPhotos.length > 0 ? (
                                                    <>
                                                        {/* Show only first 16 photos */}
                                                        {currentDisplayPhotos.slice(0, 16).map((photo, index) => (
                                                            <div
                                                                key={index}
                                                                className="portfolio-photo-item"
                                                                onClick={() => openImagePreview(photo, currentDisplayPhotos, index, currentDisplayTitle)}
                                                            >
                                                                <img
                                                                    src={photo}
                                                                    alt={`${currentDisplayTitle} photo ${index + 1}`}
                                                                    className="portfolio-photo"
                                                                    loading="lazy"
                                                                    decoding="async"
                                                                    onError={(e) => {
                                                                        e.target.src = 'https://images.pexels.com/photos/1264210/pexels-photo-1264210.jpeg';
                                                                    }}
                                                                    onContextMenu={handleRightClick}
                                                                    onDragStart={handleDragStart}
                                                                />
                                                            </div>
                                                        ))}
                                                        
                                                        {/* See More button if there are more than 16 photos */}
                                                        {currentDisplayPhotos.length > 16 && (
                                                            <div className="see-more-container">
                                                                <button 
                                                                    className="see-more-photos-btn"
                                                                    onClick={() => {
                                                                        setAllPhotosData(currentDisplayPhotos);
                                                                        setAllPhotosTitle(currentDisplayTitle);
                                                                        setShowAllPhotosModal(true);
                                                                        document.body.style.overflow = 'hidden';
                                                                    }}
                                                                >
                                                                    <svg className="pp-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><rect x="3" y="3" width="14" height="14" rx="2"/><path d="M21 7v12a2 2 0 0 1-2 2H7"/></svg>
                                                                    See More 
                                                                </button>
                                                            </div>
                                                        )}
                                                    </>
                                                ) : (
                                                    <div className="no-work">
                                                        <svg className="pp-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><rect x="2" y="4" width="13" height="12" rx="2"/><path d="m22 7-5 4 5 4V7Z"/></svg>
                                                        <p>No photos available in this {currentDisplayTitle.toLowerCase()}</p>
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </div>
                
                {/* Footer */}
               <footer className="landing-footer">
  <div className="landing-footer-content">
    <div className="landing-footer-text">
      <p>Whether it's your big day, a milestone, or just because - we bring the moment, we'll make it Lit!</p>
    </div>
    <div className="landing-subscription">
      <p>Subscribe and be first to get offers</p>
      <form className="landing-subscription-form" onSubmit={handleSubscribe}>
        <input 
          type="email" 
          placeholder="Enter your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <button type="submit" className="landing-subscribe-btn">Subscribe!</button>
      </form>
    </div>
  </div>
  
  <div className="landing-social-links">
    <button type="button" className="landing-social-link" onClick={() => window.open('https://facebook.com', '_blank')}>
      <span>f</span>
    </button>
    <button type="button" className="landing-social-link" onClick={() => window.open('https://www.linkedin.com/company/thelitstudio/', '_blank')}>
      <span>in</span>
    </button>
    <button type="button" className="landing-social-link" onClick={() => window.open('https://www.instagram.com/litstudio.in/', '_blank')}>
      <span>ig</span>
    </button>
  </div>
  
  <div className="landing-footer-bottom">
    <p>&copy; 2025 LitStudio. All rights reserved.</p>
    <div className="landing-footer-links">
     <button type="button" onClick={() => setShowPrivacy(true)}>Privacy</button>

      <button type="button" onClick={() => setShowCookie(true)}>Cookie Settings</button>
      <button type="button" onClick={() => setShowTerms(true)}>Terms & Conditions</button>
    </div>
  </div>

  {/* Privacy Policy Modal */}
  <Modal 
    isOpen={showPrivacy} 
    onClose={() => setShowPrivacy(false)}
    title="Privacy Policy"
  >
    <p><strong>Effective Date:</strong> November 22, 2025</p>
    <p><strong>Last Updated:</strong> November 22, 2025</p>

    <h3>1. Introduction</h3>
    <p>
      Welcome to LitStudio ("we," "our," or "us"). We are committed to protecting your personal information and your right to privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website and use our photography marketplace services.
    </p>

    <h3>2. Information We Collect</h3>
    
    <h4>2.1 Personal Information</h4>
    <p>We collect personal information that you voluntarily provide to us when you:</p>
    <ul>
      <li>Register on the platform as a user or photographer</li>
      <li>Make a booking or enquiry</li>
      <li>Subscribe to our newsletter</li>
      <li>Contact us for support</li>
    </ul>
    <p>This information may include:</p>
    <ul>
      <li>Full name and contact details (email address, phone number)</li>
      <li>Event details (type, date, location, requirements)</li>
      <li>Payment information (processed securely through third-party providers)</li>
      <li>Profile information and photographs (for photographers)</li>
      <li>User preferences and booking history</li>
    </ul>

    <h4>2.2 Automatically Collected Information</h4>
    <p>When you visit our website, we automatically collect certain information about your device, including:</p>
    <ul>
      <li>IP address and browser type</li>
      <li>Operating system and device information</li>
      <li>Usage data and browsing patterns</li>
      <li>Cookies and similar tracking technologies</li>
    </ul>

    <h3>3. How We Use Your Information</h3>
    <p>We use the information we collect to:</p>
    <ul>
      <li>Provide, operate, and maintain our photography marketplace services</li>
      <li>Process bookings and facilitate connections between clients and photographers</li>
      <li>Send you booking confirmations, updates, and customer support communications</li>
      <li>Improve our website and personalize your experience</li>
      <li>Send promotional emails and newsletters (with your consent)</li>
      <li>Detect, prevent, and address technical issues or fraudulent activity</li>
      <li>Comply with legal obligations and enforce our Terms & Conditions</li>
    </ul>

    <h3>4. Information Sharing and Disclosure</h3>
    <p>We do not sell your personal information. We may share your information with:</p>
    <ul>
      <li><strong>Photographers:</strong> When you make a booking, we share necessary details with the photographer</li>
      <li><strong>Service Providers:</strong> Third-party vendors who assist us (payment processors, email services, analytics)</li>
      <li><strong>Legal Compliance:</strong> When required by law or to protect our rights</li>
      <li><strong>Business Transfers:</strong> In connection with any merger, sale, or acquisition</li>
    </ul>

    <h3>5. Data Security</h3>
    <p>
      We implement appropriate technical and organizational security measures to protect your personal information. However, no method of transmission over the Internet is 100% secure, and we cannot guarantee absolute security.
    </p>

    <h3>6. Your Rights and Choices</h3>
    <p>You have the right to:</p>
    <ul>
      <li>Access, update, or delete your personal information</li>
      <li>Opt-out of marketing communications</li>
      <li>Disable cookies through your browser settings</li>
      <li>Request a copy of your data</li>
      <li>Withdraw consent for data processing</li>
    </ul>

    <h3>7. Data Retention</h3>
    <p>
      We retain your personal information only for as long as necessary to fulfill the purposes outlined in this Privacy Policy, unless a longer retention period is required by law.
    </p>

    <h3>8. Children's Privacy</h3>
    <p>
      Our services are not intended for individuals under the age of 18. We do not knowingly collect personal information from children. If you believe we have collected information from a child, please contact us immediately.
    </p>

    <h3>9. Third-Party Links</h3>
    <p>
      Our website may contain links to third-party websites. We are not responsible for the privacy practices of these external sites. We encourage you to review their privacy policies.
    </p>

    <h3>10. Changes to This Privacy Policy</h3>
    <p>
      We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last Updated" date.
    </p>

    <h3>11. Contact Us</h3>
    <p>If you have questions about this Privacy Policy, please contact us:</p>
    <ul>
      <li><strong>Email:</strong>support@litstudio.in</li>
      <li><strong>Address:</strong> LitStudio, India</li>
    </ul>
  </Modal>

  {/* Cookie Policy Modal */}
  <Modal
    isOpen={showCookie}
    onClose={() => setShowCookie(false)}
    title="Cookie Policy"
  >
    <p><strong>Effective Date:</strong> November 22, 2025</p>
    <p><strong>Last Updated:</strong> November 22, 2025</p>

    <h3>1. What Are Cookies</h3>
    <p>
      Cookies are small text files stored on your device when you visit a website. They help the site remember information about your visit, such as your login session, so you don't have to re-enter it every time.
    </p>

    <h3>2. How We Use Cookies</h3>
    <p>
      LitStudio uses cookies for essential purposes only — primarily to keep you signed in and to remember your session while you browse or manage a booking. We do not currently use cookies for advertising, and we do not sell or share cookie data with third-party advertisers.
    </p>

    <h3>3. Types of Cookies We Use</h3>
    <ul>
      <li><strong>Strictly Necessary:</strong> Required for core functionality such as authentication and keeping you logged in. The site cannot function properly without these.</li>
      <li><strong>Preference Cookies:</strong> Remember choices you've made, such as your account type, so you don't have to set them again on each visit.</li>
    </ul>

    <h3>4. Managing Cookies</h3>
    <p>
      Most browsers let you view, manage, and delete cookies through their settings. Blocking strictly necessary cookies may prevent you from logging in or using core features of the platform.
    </p>

    <h3>5. Changes to This Policy</h3>
    <p>
      We may update this Cookie Policy from time to time. Any changes will be posted on this page with an updated "Last Updated" date.
    </p>

    <h3>6. Contact Us</h3>
    <p>If you have questions about this Cookie Policy, please contact us:</p>
    <ul>
      <li><strong>Email:</strong> support@litstudio.in</li>
      <li><strong>Address:</strong> LitStudio, India</li>
    </ul>
  </Modal>

  {/* Terms & Conditions Modal */}
  <Modal
  isOpen={showTerms}
  onClose={() => setShowTerms(false)}
  title="Terms & Conditions"
>
  <p><strong>Effective Date:</strong> November 22, 2025</p>
  <p><strong>Last Updated:</strong> November 22, 2025</p>

  <p>
    Welcome to LitStudio.in ("LitStudio", "we", "our", "us"). 
    LitStudio Technologies Private Limited operates this platform to connect Users with professional Photographers 
    for various types of shoots including weddings, events, personal portraits, food, fashion, and commercial photography.
  </p>
  <p>
    By using LitStudio, you ("User" or "Photographer") agree to comply with the following Terms & Conditions. 
    Please read them carefully before registering or making a booking.
  </p>

  <h3>1. Definitions</h3>
  <ul>
    <li><strong>Platform:</strong> The LitStudio website, mobile application, and associated services.</li>
    <li><strong>User/Client:</strong> Any individual or business using LitStudio to discover, compare, and book photographers.</li>
    <li><strong>Photographer:</strong> Any individual or business offering photography services through LitStudio.</li>
    <li><strong>Booking:</strong> A confirmed engagement between a User and a Photographer through LitStudio.</li>
    <li><strong>Content:</strong> All photographs, videos, reviews, text, logos, graphics, and other materials uploaded to the platform.</li>
    <li><strong>Intellectual Property (IP):</strong> Creative work such as photos, videos, and portfolios owned by the respective creators.</li>
  </ul>

  <h3>2. Acceptance of Terms</h3>
  <ul>
    <li>By registering or using LitStudio, you agree to these Terms, our Privacy Policy, and any future updates.</li>
    <li>You must be at least 18 years old and legally capable of entering into binding contracts.</li>
    <li>If you disagree with any part of these Terms, you must not use the platform.</li>
  </ul>

  <h3>3. Nature of Service</h3>
  <p><strong>LitStudio is a facilitator, not the service provider.</strong></p>
  <ul>
    <li>We provide a curated digital marketplace that helps Users connect with verified Photographers.</li>
    <li>All photography services are independently provided by photographers; LitStudio does not control the creative process or guarantee results.</li>
  </ul>

  <h3>4. User Terms</h3>
  
  <h4>4.1 Registration and Account</h4>
  <ul>
    <li>Users must create an account with valid contact details.</li>
    <li>Users are responsible for maintaining confidentiality of login credentials.</li>
    <li>Any suspicious activity must be immediately reported to <a href="mailto:support@litstudio.in">support@litstudio.in</a>.</li>
  </ul>

  <h4>4.2 Booking Process</h4>
  <ul>
    <li>Users can browse, select, and book photographers through the platform.</li>
    <li>Bookings are confirmed only upon successful payment through LitStudio's payment gateway.</li>
    <li>Users must provide accurate event details (date, location, duration, type, and preferences).</li>
  </ul>

  <h4>4.3 Payments and Fees</h4>
  <ul>
    <li>All payments are processed securely through LitStudio.</li>
    <li>A 1% convenience fee may apply to each booking.</li>
    <li>LitStudio holds the payment in escrow until the shoot is completed.</li>
    <li>Direct payments or offline transactions outside the platform are strictly prohibited.</li>
  </ul>

  <h4>4.4 Cancellations and Refunds</h4>
  <p><strong>Cancellation by User:</strong></p>
  <ul>
    <li>More than 7 days before the event → 80% refund</li>
    <li>Within 7 days → 50% refund</li>
    <li>Within 48 hours → No refund</li>
  </ul>
  <p><strong>Cancellation by Photographer:</strong></p>
  <ul>
    <li>Full 100% refund or replacement photographer will be provided.</li>
    <li>Refunds are processed within 7–10 business days.</li>
  </ul>

  <h4>4.5 User Conduct</h4>
  <ul>
    <li>Users must treat photographers with respect and professionalism.</li>
    <li>Harassment, abuse, or inappropriate behavior will lead to suspension or permanent ban.</li>
    <li>Users must not request or encourage photographers to bypass LitStudio for future bookings.</li>
  </ul>

  <h3>5. Photographer Terms</h3>
  
  <h4>5.1 Eligibility and Verification</h4>
  <ul>
    <li>Photographers must provide valid government-issued ID and proof of original portfolio work.</li>
    <li>All portfolios must feature the photographer's own authentic work — not copied, downloaded, or re-edited content from others.</li>
  </ul>

  <h4>5.2 Prohibition on Copying or Plagiarism</h4>
  <p>Photographers are <strong>strictly prohibited</strong> from:</p>
  <ul>
    <li>Uploading or claiming credit for others' photos or videos.</li>
    <li>Downloading, editing, or reposting work that belongs to another photographer.</li>
    <li>Using AI-generated or stock images without disclosure.</li>
  </ul>
  <p>If a photographer is found using copied or stolen work:</p>
  <ul>
    <li>The account will be permanently suspended.</li>
    <li>Payments may be withheld.</li>
    <li>Legal action may be initiated under the Copyright Act, 1957 (India).</li>
  </ul>

  <h4>5.3 Listings and Pricing</h4>
  <ul>
    <li>Photographers must accurately list services, packages, and sample work.</li>
    <li>Prices displayed must include all taxes and service charges.</li>
    <li>Once a booking is confirmed, the photographer must honor the agreed rate.</li>
  </ul>

  <h4>5.4 Membership and Commission</h4>
  <ul>
    <li>Photographers may be required to pay a monthly membership fee (₹70–₹100) to stay listed.</li>
    <li>LitStudio will deduct a 10% commission on each completed booking.</li>
  </ul>

  <h4>5.5 Delivery Commitments</h4>
  <ul>
    <li>Deliverables (edited photos/videos) must be submitted within the timeline agreed with the User.</li>
    <li>Delays beyond 7 days of the committed delivery date without valid cause may result in penalties or payment withholding.</li>
  </ul>

  <h4>5.6 Conduct and Professionalism</h4>
  <ul>
    <li>Photographers must maintain respectful behavior during shoots.</li>
    <li>Any misconduct (harassment, unprofessionalism, negligence) may result in immediate delisting.</li>
    <li>Communication with clients must remain through the LitStudio platform until the booking is confirmed.</li>
  </ul>

  <h3>6. Intellectual Property (IP) Rights</h3>
  
  <h4>6.1 Ownership</h4>
  <ul>
    <li>Photographers retain full ownership of their creative work.</li>
    <li>By uploading content, photographers grant LitStudio a non-exclusive, royalty-free license to use such content for marketing, promotional, and platform purposes.</li>
  </ul>

  <h4>6.2 Content Integrity</h4>
  <p>Users and photographers must not:</p>
  <ul>
    <li>Copy, reuse, or distribute others' photos/videos.</li>
    <li>Edit, watermark, or modify any portfolio images without permission.</li>
    <li>Claim ownership or remove author credits.</li>
  </ul>

  <h4>6.3 Copyright Violations</h4>
  <ul>
    <li>LitStudio maintains a zero-tolerance policy for plagiarism or IP theft.</li>
    <li>If reported, the accused photographer's account will be suspended immediately pending investigation.</li>
    <li>Repeat offenders will face permanent bans and legal proceedings.</li>
  </ul>

  <h3>7. Ratings, Reviews, and Feedback</h3>
  <ul>
    <li>After every booking, both User and Photographer may submit ratings and reviews.</li>
    <li>Reviews must be fair, honest, and based on personal experience.</li>
    <li>LitStudio may remove fake, offensive, or misleading reviews.</li>
    <li>Consistently high ratings may increase a photographer's visibility and tier level (Normal, Pro, Premium).</li>
  </ul>

  <h3>8. Dispute Resolution</h3>
  <ul>
    <li>Both parties should first attempt to resolve disputes amicably.</li>
    <li>If unresolved, LitStudio may mediate using booking details, chat history, and proof of delivery.</li>
    <li>LitStudio's mediation decision is final and binding for payment-related issues.</li>
  </ul>

  <h3>9. Prohibited Activities</h3>
  <p>Users or Photographers must not:</p>
  <ul>
    <li>Conduct transactions outside the LitStudio platform.</li>
    <li>Share false information, fake portfolios, or manipulated reviews.</li>
    <li>Upload offensive, obscene, or copyrighted material without permission.</li>
    <li>Attempt to hack, scrape, or misuse the platform.</li>
    <li>Engage in defamation, abuse, or discrimination against any user.</li>
  </ul>

  <h3>10. Liability and Disclaimer</h3>
  <ul>
    <li>LitStudio is not responsible for any disputes, damages, or losses arising between Users and Photographers.</li>
    <li>We do not guarantee the quality, quantity, or creative output of any service.</li>
    <li>LitStudio's total liability in any case shall not exceed the service fee earned by LitStudio from that booking.</li>
  </ul>

  <h3>11. Privacy</h3>
  <ul>
    <li>Personal data is collected, stored, and processed in accordance with our Privacy Policy.</li>
    <li>We do not sell or share personal data without consent, except when required by law.</li>
  </ul>

  <h3>12. Termination</h3>
  <ul>
    <li>LitStudio reserves the right to suspend or terminate any account for violations of these Terms.</li>
    <li>Users and Photographers may request account deletion by contacting <a href="mailto:support@litstudio.in">support@litstudio.in</a>.</li>
  </ul>

  <h3>13. Amendments</h3>
  <ul>
    <li>LitStudio may modify these Terms at any time.</li>
    <li>Updated terms will be published on this page, and continued use implies acceptance.</li>
  </ul>

  <h3>14. Governing Law</h3>
  <ul>
    <li>These Terms are governed by the laws of India.</li>
    <li>Jurisdiction for all disputes shall be the courts of Mumbai, Maharashtra.</li>
  </ul>

  <h3>15. Contact Us</h3>
  <p>For any queries, support, or grievance redressal:</p>
  <ul>
    <li><strong>Email:</strong> <a href="mailto:support@litstudio.in">support@litstudio.in</a></li>
    <li><strong>Website:</strong> <a href="https://www.litstudio.in">www.litstudio.in</a></li>
  </ul>

  <p style={{ marginTop: '24px', padding: '16px', backgroundColor: '#f3f4f6', borderRadius: '8px', fontStyle: 'italic', color: '#6b7280' }}>
    By using LitStudio, you acknowledge that you have read, understood, and agree to be bound by these Terms and Conditions.
  </p>
</Modal>
</footer>

                
                {/* Image Preview Modal */}
                {showImagePreview && (
                    <div className="image-preview-overlay" onClick={closeImagePreview}>
                        <div className="image-preview-container" onClick={(e) => e.stopPropagation()}>
                            <button className="image-preview-close" onClick={closeImagePreview}>
                                <svg className="pp-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                            </button>
                            
                            {previewImageList.length > 1 && (
                                <>
                                    <button 
                                        className="image-preview-nav prev" 
                                        onClick={() => navigatePreviewImage('prev')}
                                    >
                                        <svg className="pp-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><polyline points="15 18 9 12 15 6"/></svg>
                                    </button>
                                    <button 
                                        className="image-preview-nav next" 
                                        onClick={() => navigatePreviewImage('next')}
                                    >
                                        <svg className="pp-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><polyline points="9 18 15 12 9 6"/></svg>
                                    </button>
                                </>
                            )}
                            
                            <div className="image-preview-content">
                                <img 
                                    src={previewImage} 
                                    alt={`${previewImageTitle} ${previewImageIndex + 1}`}
                                    className="preview-image"
                                    onError={(e) => {
                                        e.target.src = 'https://images.pexels.com/photos/1264210/pexels-photo-1264210.jpeg';
                                    }}
                                    onContextMenu={handleRightClick}
                                    onDragStart={handleDragStart}
                                />
                                
                                {previewImageTitle && (
                                    <div className="image-preview-info">
                                        <h3>{previewImageTitle}</h3>
                                        {previewImageList.length > 1 && (
                                            <p>{previewImageIndex + 1} of {previewImageList.length}</p>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                )}

                {/* All Photos Modal */}
                {showAllPhotosModal && (
                    <div className="all-photos-modal-overlay" onClick={() => {
                        setShowAllPhotosModal(false);
                        setAllPhotosData([]);
                        setAllPhotosTitle('');
                        document.body.style.overflow = 'auto';
                    }}>
                        <div className="all-photos-modal-content" onClick={(e) => e.stopPropagation()}>
                            <div className="all-photos-modal-header">
                                <h2>All Photos - {allPhotosTitle}</h2>
                                <div className="all-photos-modal-info">
                                    <span>{allPhotosData.length} photos total</span>
                                </div>
                                <button 
                                    className="all-photos-modal-close" 
                                    onClick={() => {
                                        setShowAllPhotosModal(false);
                                        setAllPhotosData([]);
                                        setAllPhotosTitle('');
                                        document.body.style.overflow = 'auto';
                                    }}
                                >
                                    <svg className="pp-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                                </button>
                            </div>
                            
                            <div className="all-photos-modal-body">
                                <div className="all-photos-grid">
                                    {allPhotosData.map((photo, index) => (
                                        <div key={index} className="all-photos-item">
                                            <img 
                                                src={photo}
                                                alt={`${allPhotosTitle} photo ${index + 1}`}
                                                className="all-photos-image"
                                                onClick={() => {
                                                    openImagePreview(photo, allPhotosData, index, allPhotosTitle);
                                                    setShowAllPhotosModal(false);
                                                    document.body.style.overflow = 'hidden';
                                                }}
                                                onError={(e) => {
                                                    e.target.src = 'https://images.pexels.com/photos/1264210/pexels-photo-1264210.jpeg';
                                                }}
                                                onContextMenu={handleRightClick}
                                                onDragStart={handleDragStart}
                                            />
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                
                {/* UPDATED: Enquiry Modal with Photography suffix for shoot types */}
                {showEnquiryModal && (
                    <div className="modal-overlay" onClick={closeEnquiryModal}>
                        <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                            <div className="modal-header">
                                <h2>Send Enquiry</h2>
                                <button className="modal-close" onClick={closeEnquiryModal}>
                                    <svg className="pp-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                                </button>
                            </div>
                            
                            <form onSubmit={handleEnquirySubmit} className="enquiry-form">
                                <div className="form-grid">
                                    <div className="form-group">
                                        <label htmlFor="location">
                                            <svg className="pp-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/><circle cx="12" cy="10" r="3"/></svg>
                                            Location
                                        </label>
                                        <input
                                            type="text"
                                            id="location"
                                            name="location"
                                            value={enquiryForm.location}
                                            onChange={handleEnquiryFormChange}
                                            placeholder="Enter shoot location"
                                            required
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label>
                                            <svg className="pp-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
                                            Preferred Date
                                        </label>
                                        <DatePicker
                                            selected={enquiryForm.preferredDate}
                                            onChange={handleDateChange}
                                            minDate={new Date()}
                                            dateFormat="MMMM d, yyyy"
                                            className="date-picker"
                                            placeholderText="Select date"
                                            required
                                        />
                                    </div>

                                    {/* UPDATED: Budget Range as Input Field */}
                                    <div className="form-group">
                                        <label htmlFor="budget">
                                            <svg className="pp-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M6 3h12M6 8h12M15 3c0 5-3 5-9 5l9 13"/></svg>
                                            Budget Range
                                        </label>
                                        <input
                                            type="text"
                                            id="budget"
                                            name="budget"
                                            value={enquiryForm.budget}
                                            onChange={handleEnquiryFormChange}
                                            placeholder="e.g., ₹50,000 - ₹1,00,000 or ₹75,000"
                                            required
                                        />
                                        <small style={{ color: '#6b7280', fontSize: '12px' }}>
                                            Enter your budget range or specific amount
                                        </small>
                                    </div>

                                    {/* UPDATED: Type of Shoot with Photography suffix */}
                                    <div className="form-group">
                                        <label htmlFor="typeOfShoot">
                                            <svg className="pp-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3Z"/><circle cx="12" cy="13" r="3.5"/></svg>
                                            Type of Shoot
                                        </label>
                                        <select
                                            id="typeOfShoot"
                                            name="typeOfShoot"
                                            value={enquiryForm.typeOfShoot}
                                            onChange={handleEnquiryFormChange}
                                            required
                                        >
                                            <option value="">Select shoot type</option>
                                            {availableShootTypes.map((shootType, index) => (
                                                <option key={index} value={shootType.value}>
                                                    {shootType.label}
                                                </option>
                                            ))}
                                        </select>
                                        {availableShootTypes.length > 0 && (
                                            <small style={{ color: '#6b7280', fontSize: '12px' }}>
                                                Options based on {photographerData.name}'s available services
                                            </small>
                                        )}
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="timeOfDay">
                                            <svg className="pp-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
                                            Time of Day
                                        </label>
                                        <select
                                            id="timeOfDay"
                                            name="timeOfDay"
                                            value={enquiryForm.timeOfDay}
                                            onChange={handleEnquiryFormChange}
                                            required
                                        >
                                            <option value="">Select time</option>
                                            <option value="morning">Morning (6 AM - 12 PM)</option>
                                            <option value="afternoon">Afternoon (12 PM - 6 PM)</option>
                                            <option value="evening">Evening (6 PM - 10 PM)</option>
                                            <option value="flexible">Flexible</option>
                                        </select>
                                    </div>

                                    <div className="form-group form-group-full">
                                        <label htmlFor="message">
                                            <svg className="pp-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.1 2.1 0 0 1 3 3L12 15l-4 1 1-4Z"/></svg>
                                            Short Message (Optional)
                                        </label>
                                        <textarea
                                            id="message"
                                            name="message"
                                            value={enquiryForm.message}
                                            onChange={handleEnquiryFormChange}
                                            placeholder="Any specific requirements or details..."
                                            maxLength={150}
                                            rows={3}
                                        />
                                        <div className="character-count">
                                            {enquiryForm.message.length}/150 characters
                                        </div>
                                    </div>
                                </div>

                                <div className="form-actions">
                                    <button 
                                        type="button" 
                                        className="btn-secondary"
                                        onClick={closeEnquiryModal}
                                    >
                                        Cancel
                                    </button>
                                    <button 
                                        type="submit" 
                                        className="btn-primary"
                                        disabled={isSubmittingEnquiry}
                                    >
                                        {isSubmittingEnquiry ? (
                                            <>
                                                <svg className="pp-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"  className="pp-icon pp-icon-spin"><path d="M21 12a9 9 0 1 1-6.2-8.6"/></svg>
                                                Sending...
                                            </>
                                        ) : (
                                            <>
                                                <svg className="pp-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M22 2 11 13"/><path d="M22 2 15 22l-4-9-9-4 20-7Z"/></svg>
                                                Send Enquiry
                                            </>
                                        )}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                )}

                {/* UPDATED: Success Modal - Removed WhatsApp/Call buttons and tip section */}
                {showSuccessModal && (
                    <div className="modal-overlay" onClick={() => setShowSuccessModal(false)}>
                        <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                            <div className="modal-header">
                                <div className="success-icon">
                                    <svg className="pp-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><polyline points="8.5 12.5 11 15 16 9.5"/></svg>
                                </div>
                                <button className="modal-close" onClick={() => setShowSuccessModal(false)}>
                                    <svg className="pp-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                                </button>
                            </div>
                            
                            <div className="modal-body">
                                <h2>Request Sent Successfully!</h2>
                                <p className="success-message">
                                    We've shared your booking request with <strong>{photographerData.name}</strong>.<br/>
                                    They usually respond within <strong>1–2 hours</strong> via WhatsApp or phone call.
                                </p>
                                
                                <button 
                                    className="btn-primary"
                                    onClick={() => setShowSuccessModal(false)}
                                >
                                    Got it, thanks!
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default PhotographerPortfolio;
